export enum AppRoutes {
  UNKNOWN = '*',

  CASH_OUT = '/cash-out',
  ERROR = '/error',
  FORGOT_PASSWORD = '/forgot-password',
  HISTORY = '/history',
  HOME = '/',
  LOGIN = '/signin',
  MY_ACCOUNT = '/my-account',
  PRIVACY = '/privacy-policy', // TODO: [LAUNCH] Add view and form
  PROFILE = '/profile',
  REQSTS = '/reqsts',
  SETTINGS = '/settings',
  TERMS = '/terms-and-conditions', // TODO: [LAUNCH] Add view and form
  UNLOCK_ACCOUNT = '/unlock-account',

  // Onboarding
  CONFIRM_ACCOUNT = '/confirmation',
  CREATE_ACCOUNT = '/create-account',
  LINK_ACCOUNTS = '/link-accounts',
  LINK_APPLE_MUSIC = '/link-apple-music',
  LINK_TIDAL = '/link-tidal',
  OAUTH = '/oauth',
  VERIFY_ACCOUNT = '/verify-account',
  WELCOME = '/welcome',
}

export default AppRoutes
